import { createContext, Dispatch, SetStateAction, useContext, useEffect } from 'react';

export type JourneyState = 'profileInProgress' | 'profileDone';

export const QuestionnaireJourneyContext = createContext<{
  state: JourneyState;
  setState: Dispatch<SetStateAction<JourneyState>>;
  step: number | null;
  setStep: Dispatch<SetStateAction<number | null>>;
}>({ state: 'profileInProgress', setState: () => {}, step: null, setStep: () => {} });

export const useSetJourneyState = (state: JourneyState) => {
  const { setState } = useContext(QuestionnaireJourneyContext);

  useEffect(() => {
    setState(state);
  }, [setState, state]);
};

export const useSetJourneyStep = (step: number | null) => {
  const { setStep } = useContext(QuestionnaireJourneyContext);

  useEffect(() => {
    setStep(step);
    return () => setStep(null);
  }, [setStep, step]);
};
